<template>
   
    <nav class="navbar navbar-vertical fixed-left navbar-expand-md navbar-light bg-white" id="sidenav-main">
        <div class="container-fluid">
            <!-- Toggler -->
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#sidenav-collapse-main" aria-controls="sidenav-main" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <!-- Brand -->
            <router-link class="navbar-brand pt-0" :to="{name:'launchpad'}">
                <img src="https://s3-ap-southeast-2.amazonaws.com/resource.csnstatic.com/retail/globals/logo/v5/chileautos.png" class="navbar-brand-img" alt="...">
            </router-link>
            <!-- User -->
            <ul class="nav align-items-center d-md-none">
                <li class="nav-item dropdown">
                    <a class="nav-link" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <div class="media align-items-center">
                            <span class="avatar avatar-sm rounded-circle">
                      <img alt="Image placeholder" src="@/assets/img/default.png">
                    </span>
                        </div>
                    </a>
                    <div class="dropdown-menu dropdown-menu-arrow dropdown-menu-right">
                        <div class=" dropdown-header noti-title">
                            <h6 class="text-overflow m-0">¡Bienvenido!</h6>
                        </div>
                        <router-link :to="{ name: 'account' }" class="dropdown-item">
                        <i class="ni ni-single-02"></i>
                        <span>Mi Cuenta</span>
                        </router-link>
                        <router-link :to="{ name: 'account'}" class="dropdown-item d-none">
                        <i class="ni ni-settings-gear-65"></i>
                        <span>Configuración</span>
                        </router-link>
                        <div class="dropdown-divider"></div>
                        <button @click="logout()" class="dropdown-item">
                        <i class="ni ni-user-run"></i>
                        <span>Cerrar sesión</span>
                        </button>
                    </div>
                </li>
            </ul>
            <!-- Collapse -->
            <div class="collapse navbar-collapse" id="sidenav-collapse-main">
                <!-- Collapse header -->
                <div class="navbar-collapse-header d-md-none">
                    <div class="row">
                        <div class="col-6 collapse-brand">
                            <router-link :to="{name:'launchpad'}">
                                
                                <img :src="'https://ui-avatars.com/api/?background=E91E63&color=fff&name=' + user.name" class="navbar-brand-img" alt="...">
                                <img src="@/assets/img/logo.svg" class="navbar-brand-img d-none" alt="...">
                            </router-link>
                        </div>
                        <div class="col-6 collapse-close">
                            <button type="button" class="navbar-toggler" data-toggle="collapse" data-target="#sidenav-collapse-main" aria-controls="sidenav-main" aria-expanded="false" aria-label="Toggle sidenav">
                                <span></span>
                                <span></span>
                            </button>
                        </div>
                    </div>
                </div>
                <!-- Navigation -->
                <ul class="navbar-nav">
                    <li class="nav-item">
                        <router-link class="nav-link" :to="{name:'launchpad'}"><i class="fa fa-home text-theme"></i> Launchpad</router-link>
                    </li>
                    <li class="nav-item" v-for="(m, index) in menus" :key="m.name">
                        <router-link v-if="m.submenu" data-toggle="collapse" :data-target="'#submenu'+index" class="nav-link" :to="{name:m.name}">{{m.caption}}</router-link>
                        <router-link v-if="!m.submenu" class="nav-link" :to="{name:m.name}">{{m.caption}}</router-link>
                        <ul v-if="m.submenu" :id="'submenu'+index" class="collapse">
                            <li v-for="s in m.submenu" :key="s.name">
                                <router-link class="nav-link" :to="{name:s.name}">{{s.caption}}</router-link>
                            </li>
                        </ul>
                    </li>
                </ul>
                <!-- Divider -->
                <hr class="my-3">
            </div>
        </div>
    </nav>
</template>
<script>
import Auth from "@/helpers/middleware";
export default {
  name: "spinner",
  data() {
    return {
      user: Auth.getUser(),
      menus: Auth.getMenu()
    };
  },
  created() {
    if(!this.menus && !this.$route.meta.logged){
        this.$router.push({name:'not-found'});
    }
  },
  methods:{
    logout(){
      Auth.logOut()
    }
  }
};
</script>
<style lang="scss" scoped>
.navbar-light .navbar-nav .nav-link {
    color: rgba(0, 0, 0, 1);
}
</style>